import { useContext } from 'react'

import AlertStatusesContext from './AlertStatusesContext'

const useAlertStatuses = () => {
  const ctx = useContext(AlertStatusesContext)

  if (!ctx) {
    throw new Error('useAlertStatuses must be used within AlertStatusesProvider')
  }

  return ctx
}

export default useAlertStatuses
